import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { ExternalModuleConfig } from './external-module.types';

@Injectable({ providedIn: 'root' })
export class ExternalModulesService {
    readonly modules: ExternalModuleConfig[] = environment.externalModules ?? [];

    getById(id: string): ExternalModuleConfig | undefined {
        return this.modules.find((m) => m.id === id);
    }
}
